export default __webpack_public_path__ + "static/media/memory.d3462be9.jpeg";